import { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { object } from 'yup'
import { useUser } from '../../common/hooks/auth/useUser'
import InfoMessage from '../../components/common/info-message'
import MainNav from '../../components/homepage/main-nav'
import Layout from '../../components/layout/layout'
import { useTranslation } from '../../useTranslation'
import ForgotPassword from './forgot-password'
import { LanguageKey, UserValidationRules } from '@ringo/shared'

export const Init: FC = () => {
    const { t } = useTranslation()
    const { updateUserLanguage } = useUser()

    const [params] = useSearchParams()
    const email = params.get('email')

    useEffect(() => {
        const lang = params.get('lang') as LanguageKey
        if (!lang) return
        updateUserLanguage(lang)
    }, [])

    let emailValidationSchema = object({
        email: UserValidationRules.email(),
    })

    if (!email || !emailValidationSchema.isValidSync({ email }))
        return (
            <Layout>
                <MainNav />
                <div className="px-56">
                    <InfoMessage type={'error'} label={t('validations.email')}></InfoMessage>
                </div>
            </Layout>
        )

    return (
        <ForgotPassword
            customMessage={t('createAccount.authInitWelcomeMessage')}
            customTitle={t('createAccount.authInitWelcomeTitle')}
            hideCancel
            prefilledEmail={email}
        ></ForgotPassword>
    )
}
